





























import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

@Component({})
export default class OrbitCountdown extends Vue {
  @Prop({type: Number, default: null})
  endTimestampMs!: number | null

  @Prop({type: String, required: true})
  label!: string

  private remainingSeconds = 0
  private countdownInterval: number | null = null

  get shouldShow(): boolean {
    if (this.endTimestampMs == null || this.endTimestampMs <= 0) {
      return false
    }
    return !isNaN(this.endTimestampMs) && this.remainingSeconds > 0
  }

  mounted() {
    this.startCountdown()
  }

  beforeDestroy() {
    this.stopCountdown()
  }

  @Watch('endTimestampMs')
  onEndTimestampChange() {
    this.stopCountdown()
    this.startCountdown()
  }

  startCountdown() {
    const endMs = this.endTimestampMs
    if (endMs == null || endMs <= 0 || isNaN(endMs) || endMs <= Date.now()) {
      this.remainingSeconds = 0
      return
    }

    const updateCountdown = () => {
      const now = Date.now()
      const diff = Math.max(0, Math.floor((endMs - now) / 1000))
      this.remainingSeconds = diff

      if (diff === 0) {
        this.stopCountdown()
        this.$emit('expired')
      }
    }

    updateCountdown()
    this.countdownInterval = window.setInterval(updateCountdown, 1000)
  }

  stopCountdown() {
    if (this.countdownInterval != null) {
      clearInterval(this.countdownInterval)
      this.countdownInterval = null
    }
  }

  get formattedTime() {
    if (this.remainingSeconds <= 0) {
      return '0:00'
    }

    const days = Math.floor(this.remainingSeconds / 86400)
    const hours = Math.floor((this.remainingSeconds % 86400) / 3600)
    const minutes = Math.floor((this.remainingSeconds % 3600) / 60)
    const seconds = this.remainingSeconds % 60

    if (days > 0) {
      return `${days}d ${String(hours).padStart(2, '0')}:${String(
        minutes
      ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    }

    if (hours > 0) {
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0'
      )}:${String(seconds).padStart(2, '0')}`
    }

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
      2,
      '0'
    )}`
  }
}
